module.exports = __webpack_public_path__ + "img/rhoc.0281e146.svg";